import { Injectable } from '@angular/core';
import { ErrorHandlingService } from '../../../core/services/error-handling.service';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { ApiResponse } from '../../../core/models/api-response.models';
import { environment } from '../../../../environments/environment.development';
import {
  ApiResponseReportPaginated,
  ExportPayload,
  ReportRequestPayload,
} from './insights-admin.interface';

@Injectable({
  providedIn: 'root',
})
export class ReportManagerService {
  private readonly API_URL = environment.apiUrl;
  private readonly REPORTS_API = `${this.API_URL}/behaviorreport`;
  private readonly BEHAVIOR_REPORTS_API = `${this.API_URL}/behaviorreportexport`;

  constructor(
    private readonly errorHandler: ErrorHandlingService,
    private readonly http: HttpClient
  ) {}

  generateReport(payload: ReportRequestPayload) {
    return this.http
      .post<ApiResponse<void>>(`${this.REPORTS_API}/initiate-export`, payload)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  private buildQueryParams({
    page,
    pageSize,
    sortOrder,
    sort,
    jobTypeId,
  }: ExportPayload): HttpParams {
    let params = new HttpParams()
      .set('Page', page.toString())
      .set('PageSize', pageSize.toString())
      .set('jobTypeId', jobTypeId.toString());

    if (sort) {
      params = params.set('sort', sort);
    }

    if (sortOrder !== undefined) {
      params = params.set('sortOrder', sortOrder.toString());
    }

    return params;
  }

  getExportedProgressReport(payload: ExportPayload) {
    const params = this.buildQueryParams(payload);
    return this.http
      .get<ApiResponseReportPaginated>(
        `${this.BEHAVIOR_REPORTS_API}/exported-progress-report`,
        { params }
      )
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  downloadReport(jobId: number): Observable<HttpResponse<Blob>> {
    const params = new HttpParams().set('jobId', jobId.toString());

    return this.http
      .get(`${this.BEHAVIOR_REPORTS_API}/download-report`, {
        params,
        observe: 'response',
        responseType: 'blob',
      })
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}
